export default __webpack_public_path__ + "static/media/decline.f159f04c.svg";